import { AddressCard } from '@equip.health/ui';

import { UserRole } from '~/lib/constants/patients.constants';
import { formatCellPhoneNumber } from '~/lib/util/patient.util';

interface Address {
  name: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zipCode: string;
  phoneNumber: string;
  email: string;
  userRole?: UserRole;
}

interface ShippingAddressProps {
  addresses: Address[];
  onSelectAddress: (address: Address) => void;
}
const TOP_LEVEL_ID = 'shipping-address';

const ShippingAddress = ({
  addresses,
  onSelectAddress,
}: ShippingAddressProps) => {
  return (
    <>
      {addresses.map((address, index) => (
        <AddressCard
          addressLine1={address.addressLine1}
          addressLine2={address.addressLine2}
          city={address.city}
          email={address.email}
          handleUseThisAddressClick={() => onSelectAddress(address)}
          id={`${TOP_LEVEL_ID}__address-card`}
          key={index}
          name={address?.name}
          phoneNumber={formatCellPhoneNumber(address?.phoneNumber)}
          ShouldShowButton
          state={address.state}
          userRole={address?.userRole}
          zipCode={address.zipCode}
        />
      ))}
    </>
  );
};

export default ShippingAddress;
